import { FC } from "react";
import PageTemplate from "../PageTemplate";
import UserProfilePage from "./UserProfilePage";

const UserProfile: FC = () => {
    return <PageTemplate Page={UserProfilePage} />;
};

export default UserProfile;
